import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

const useStore = () => {
    return useContext(MobXProviderContext).myStore;
};

export default useStore;
